export default {
    title: 'Rolle erstellen',
    createRole: 'Rolle erstellen',
    createAndEditRole: 'Erstellen und weiter bearbeiten',
    createRoleSuccess: 'Die Rolle wurde erfolgreich erstellt.',
    createRoleError: 'Die Rolle konnte nicht erstellt werden.'
}